import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, map, tap } from 'rxjs';

import { OFFER_SERVER_URL } from '../../config';
import { CodeValue } from '../../shared/models/code-value';
import {
	ProductCharacteristicsTranslationService
} from '../../shared/services/product-characteristics-translation.services';
import {
	ProductA2c, ProductFamily, TemplateDescription,
	TranslationType
} from '../models/eorder';

const PRODUCT_FAMILY_LIST_URL = `${ OFFER_SERVER_URL }/v3/products:families`;
const PRODUCT_TEMPLATE_DETAILS = `${ OFFER_SERVER_URL }/v2/template:search`;
const PRODUCTS_DETAILS = `${ OFFER_SERVER_URL }/v3/products`;
const FIELD_NAMES_URL = `${ OFFER_SERVER_URL }/products:fields`;

@Injectable({ providedIn: 'root' })
export class ProductService {
	familyProductClickEvent: Observable<string>;
	private readonly familyProductClickSubject = new Subject<string>();
	constructor(
		private readonly http: HttpClient,
		private readonly productCharacteristicsTranslationService: ProductCharacteristicsTranslationService
	) {
		this.familyProductClickEvent = this.familyProductClickSubject.asObservable();
	}

	emitFamilyProductClickEvent(data: string) {
		this.familyProductClickSubject.next(data);
	}

	getProductFamily(
		soldTo: string,
		periodInMonth?: number,
		translationType?: TranslationType
	) {
		const productfamilyUrl = new URL(PRODUCT_FAMILY_LIST_URL);
		const params = productfamilyUrl.searchParams;
		params.append('soldTo', soldTo);
		params.append('serviceCode', 'EORDR');
		if (periodInMonth !== undefined) {
			params.append('month', String(periodInMonth));
		}
		if (translationType !== undefined) {
			params.append('translation', String(translationType));
		}
		return this.http.get<ProductFamily[]>(productfamilyUrl.toString());
	}

	getTemplateDetails(templateNumber: number) {
		const dataUrl = new URL(PRODUCT_TEMPLATE_DETAILS);
		const params = dataUrl.searchParams;
		if (templateNumber) {
			params.append('templateNumber', templateNumber.toString());
		}
		return this.http.get<TemplateDescription>(dataUrl.toString());
	}

	getProductsDetails(subCategory: string, form: string, soldTo: string) {
		const dataUrl = new URL(PRODUCTS_DETAILS);
		const params = dataUrl.searchParams;
		if (soldTo) {
			params.append('soldTo', soldTo);
		}
		if (subCategory) {
			params.append('subCategory', subCategory);
		}
		if (form) {
			params.append('form', form);
		}
		params.append('serviceCode', 'EORDR');
		return this.http.get<ProductA2c[]>(dataUrl.toString());
	}

	loadFieldNameTranslations(
		a2c: boolean
	) {
		const url = new URL(FIELD_NAMES_URL);
		const params = url.searchParams;
		params.append('a2c', String(a2c));
		return this.http.get<CodeValue[]>(url.toString())
			.pipe(
				tap(fieldNameTranslations => {
					this.productCharacteristicsTranslationService.add(fieldNameTranslations);
				}),
				map(() => true)
			);
	}
}
